
        export default {"base":"components/ThemeWrapper/themes/base.js"};
    